import { formValueSelector } from 'redux-form';
import uniqBy from 'lodash/uniqBy';
import { Tier } from '@eti/schema-types';
import { price as priceUtils } from '@eti/utils';
import { BUNDLE_PRODUCT } from './constants';
export const getSelected = (name, form) => state => {
  var _formData$value;
  const formData = formValueSelector(form)(state, name);
  return (_formData$value = formData === null || formData === void 0 ? void 0 : formData.value) !== null && _formData$value !== void 0 ? _formData$value : null;
};
export const getGraphQlSelection = _ref => {
  let {
    state,
    form
  } = _ref;
  return getSelected(BUNDLE_PRODUCT, form)(state);
};
const getPrice = function (value, options) {
  if (options === void 0) {
    options = [];
  }
  return (options.find(_ref2 => {
    let {
      type
    } = _ref2;
    return type === value;
  }) || {}).priceRaw || 0;
};
const getId = function (value, options) {
  if (options === void 0) {
    options = [];
  }
  return (options.find(_ref3 => {
    let {
      type
    } = _ref3;
    return type === value;
  }) || {}).id || null;
};
export const formatSet = options => value => {
  return {
    value: value || null,
    price: getPrice(value, options),
    id: getId(value, options)
  };
};
export const formatGet = bundle => bundle ? bundle.value : null;
export const orderBundles = type => {
  switch (type) {
    case Tier.Basic:
      return {
        desktopOrder: 1,
        mobileOrder: 3
      };
    case Tier.Recommended:
    case Tier.Premium:
    default:
      return {
        desktopOrder: 2,
        mobileOrder: 1
      };
  }
};
export const getBundleName = item => `${BUNDLE_PRODUCT}.${item.id}`;
export const getBundlePosition = (options, selectedType) => {
  return options.findIndex(_ref4 => {
    let {
      type
    } = _ref4;
    return type === selectedType;
  });
};
export const getNewActiveBundle = function (options, selectedBundleToOpen) {
  if (options === void 0) {
    options = [];
  }
  return options.filter(currentBundle => {
    const bundleName = getBundleName(currentBundle);
    return bundleName === selectedBundleToOpen;
  })[0];
};
export const getUniqFeatures = function (options) {
  if (options === void 0) {
    options = [];
  }
  return uniqBy(options.reduce((acc, _ref5) => {
    let {
      features,
      title
    } = _ref5;
    const featuresWithTitle = features.map(feature => ({
      ...feature,
      title
    }));
    return [...acc, ...featuresWithTitle];
  }, []), 'name');
};
export const getRowsData = options => getUniqFeatures(options).map((_ref6, rowIndex) => {
  let {
    description,
    name,
    pieces,
    weight,
    weightUnit,
    productTypeId
  } = _ref6;
  return {
    productTypeId,
    description,
    name,
    optionColumns: options.map(_ref7 => {
      let {
        features,
        type,
        id,
        title
      } = _ref7;
      return {
        included: Boolean(features.find(_ref8 => {
          let {
            name: optionName
          } = _ref8;
          return optionName === name;
        })),
        isRecommended: type === Tier.Recommended,
        optionId: id,
        title
      };
    }),
    pieces,
    rowIndex,
    weight,
    weightUnit
  };
});
export const getPriorities = recommendedPriority => ({
  BASIC: 0,
  RECOMMENDED: recommendedPriority,
  PREMIUM: recommendedPriority === 1 ? 2 : 1,
  DELUXE: 3
});
const prioritiesMobile = {
  RECOMMENDED: 0,
  DELUXE: 1,
  PREMIUM: 2,
  BASIC: 3
};
export const sortOptions = function (options) {
  var _options;
  if (options === void 0) {
    options = [];
  }
  const recommendedPriority = Math.max(((_options = options) === null || _options === void 0 ? void 0 : _options.length) - 2, 1);
  const priorities = getPriorities(recommendedPriority);
  return [...options].sort((a, b) => priorities[a.type] - priorities[b.type]);
};
export const mobileBundleOptionOrder = sellableOptions => [...sellableOptions].sort((a, b) => prioritiesMobile[a.type] - prioritiesMobile[b.type]);
export const stylesVariables = {
  firstColumnWidth: 'calc(100% / 3)',
  recommendedBackground: '#fafafa',
  rowsHeight: '56px'
};
export const formatPrice = price => `+${priceUtils.formatPrice(price)}`;
export const formatOriginalPrice = price => `${priceUtils.formatPrice(price)}`;
//# sourceMappingURL=utils.js.map